<template>
  <v-row class="d-flex">
    <v-col md="6" sm="12">
      <v-container>
        <v-card rounded>
          <v-card-title>
            If you need some improvements or changes, please fill in the form.
            Developer will try to code all your wants 😇
          </v-card-title>
          <v-text-field
            v-model="text"
            label="Your wish"
            class="mx-4"
          ></v-text-field>
          <v-btn color="#06bab1" class="mx-4 mb-5" @click="send_wish" dark>
            Send
            <v-icon class="ml-2">mdi-send</v-icon>
          </v-btn>
          <p
            class='ml-4 text-h6'
            v-if='success'
            >Sent successfully!</p>
        </v-card>
      </v-container>
    </v-col>
    <v-col md="6" sm="12">
      <v-card rounded>
        <v-card-title>
          <v-icon color="#e16979" class="mr-2" large>mdi-xml</v-icon>
          In develop
          <v-icon color="#e16979" class="ml-2" large>mdi-xml</v-icon>
        </v-card-title>
        <v-list>
          <v-list-item-group v-model="selectedItem" color="red">
            <v-list-item v-for="(item, i) in plans" :key="i">
              <v-list-item-icon>
                <v-icon>mdi-code-json</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  v-text="item.description"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
    metaInfo: {
    title: "INCAB Board > Feedback",
  },
  
  mounted() {
    axios.get("/api/v1/plans").then((response) => {
      this.plans = response.data;
    });
  },
  data() {
    return {
      text: "",
      plans: [],
      selectedItem: 0,
      success:false,
    };
  },
  methods: {
    send_wish() {
        axios.post("/api/v1/feedback/", {user:this.user.id,  text:this.text}).then(this.success=true)
        this.text = ''
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
};
</script>

<style scoped>
</style>  